const OSS_HTTP_URL_PATTERN = /http:\/\/([^\s"'<>]*aliyuncs\.com[^\s"'<>]*)/gi;

export function normalizeAssetUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  if (/^http:\/\/[^\s"'<>]*aliyuncs\.com/i.test(url)) {
    return url.replace(/^http:\/\//i, 'https://');
  }
  if (/^\/\/[^\s"'<>]*aliyuncs\.com/i.test(url)) {
    return `https:${url}`;
  }
  return url;
}

export function normalizeAssetUrlsInText(content?: string | null): string {
  if (!content) return '';
  return content.replace(OSS_HTTP_URL_PATTERN, 'https://$1');
}
